import { requests } from '.';
export const DomainConnectServices = {
    initDomainConnectRootDomain: (params) => requests().get(`/a-record`, { params }),
    initDomainConnectRootDomainAndCNameRecord: (params) => requests().get(`/a-cname-record`, { params }),
    initDomainConnectRootDomainAndTxtSslRecord: (params) => requests().get(`/a-txt-ssl-record`, { params }),
    initDomainConnectCname: (params) => requests().get(`/cname`, { params }),
    initDomainConnectTxtSsl: (params) => requests().get(`/txt-ssl`, { params }),
    initDomainConnectTxtDynamic: (params) => requests().get(`/txt-dynamic`, { params }),
    initDomainConnectEmail: (params) => requests().get(`/email`, { params }),
    verifyDNSProviderTemplateData: (data) => requests().post(`/verify-domain-connect-template`, data),
    migrateDNSRecords: (data) => requests().post(`/migrate-records`, data),
};
